export enum PageRoutes {
  Login = 'login',
  LoginError = 'login-error',
  LoginByVin = 'login-by-vin',
  LoginByVinError = 'login-by-vin-error',
  VehicleDetails = 'vehicle-details',
  ServiceRequest = 'service-request',
  SelectDealer = 'select-dealer',
  SelectServiceDate = 'select-service-date',
  PriceEstimateWithServicePlan = 'price-estimate-with-service-plan',
  PriceEstimateWithoutServicePlanPageFormData = 'price-estimate-without-service-plan',
  SelectCollectionDeliveryOptions = 'select-collection-delivery-options',
  CustomerContact = 'customer-contact',
  VerifyBookingDetails = 'verify-booking-details',
  Bookings = 'bookings',
  SendConfirmationMessage = 'send-confirmation-message',
  Error = 'error',
}
